import { add, differenceInHours } from 'date-fns';
import Link from 'next/link';

import { FormattedMessage } from '@flipster/i18n';
import { useOverlayItem } from '@flipster/overlay';
import { CountdownDate } from '@flipster/react/design-utils/countdown-date';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { convertDate } from '@flipster/utils/datetime';

import { useAuth } from '../../auth/state';

export const LossProtectionBanner = () => {
  const { user } = useAuth();
  const { close } = useOverlayItem();

  if (!user?.kycActivatedAt || !user?.showLossProtection) return null;

  const now = Date.now();
  const kycActivatedAt = convertDate(user.kycActivatedAt) || 0;
  const isShowBanner = differenceInHours(now, kycActivatedAt) < 24;

  if (!isShowBanner) return null;

  const datetime = add(kycActivatedAt, { days: 1 });

  return (
    <Link href='/marketing/new-user-loss-protection' onClick={close}>
      <div
        className={flex({
          bg: 'background.default.level-3',
          p: '12px 16px',
          gap: 4,
          borderRadius: 4,
          align: 'center',
          justify: 'space-between',
          mb: 8,
        })}
      >
        <div className={css({ flex: 1 })}>
          <div
            className={flex({
              align: 'center',
              gap: 4,
              textStyle: 'Text/M/Monospace/Strong',
              color: 'content.default.level-5',
            })}
          >
            <span>⏳</span>
            <CountdownDate
              targetDate={datetime}
              css={{ textStyle: 'Text/L/Monospace/Strong', color: 'content.default.level-5' }}
            />
          </div>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5', mt: 4 })}>
            <FormattedMessage id='Deposit.r250401.Loss_protection_banner_description' />
          </p>
        </div>
        <ChevronRightIcon color={token('colors.content.default.level-2')} size={16} />
      </div>
    </Link>
  );
};
